import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [{ //登录页面
      path: '/',
      name: 'home',
      meta: '1-1',
      component: () => import( /* webpackChunkName: "home" */ '../pages/home.vue')
    },
    /* -----------产品服务------------------------- */
    { //物联网卡页面
      path: '/internetCard',
      name: 'internetCard',
      meta: '2-1',
      component: () => import( /* webpackChunkName: "internetCard" */ '../pages/internetCard.vue')
    }, { //模组页面
      path: '/mozu',
      name: 'mozu',
      meta: '2-2',
      component: () => import( /* webpackChunkName: "mozu" */ '../pages/mozu.vue')
    }, { //开发板页面
      path: '/development',
      name: 'development',
      meta: '2-3',
      component: () => import( /* webpackChunkName: "development" */ '../pages/development.vue')
    },
    /* -------------解决方案--------------------- */
    { //水质（水文）页面
      path: '/quality',
      name: 'quality',
      meta: '3-1',
      component: () => import( /* webpackChunkName: "quality" */ '../pages/quality.vue')
    }, { //白蚁页面
      path: '/whiteAnt',
      name: 'whiteAnt',
      meta: '3-2',
      component: () => import( /* webpackChunkName: "whiteAnt" */ '../pages/whiteAnt.vue')
    }, { //大坝页面
      path: '/dam',
      name: 'dam',
      meta: '3-3',
      component: () => import( /* webpackChunkName: "dam" */ '../pages/dam.vue')
    }, { //巡水页面
      path: '/cruiseWater',
      name: 'cruiseWater',
      meta: '3-4',
      component: () => import( /* webpackChunkName: "cruiseWater" */ '../pages/cruiseWater.vue')
    }, { //灌区信息化管理系统页面
      path: '/irrigatedArea',
      name: 'irrigatedArea',
      meta: '3-5',
      component: () => import( /* webpackChunkName: "irrigatedArea" */ '../pages/irrigatedArea.vue')
    }, { //资产管理系统页面
      path: '/property',
      name: 'property',
      meta: '3-6',
      component: () => import( /* webpackChunkName: "property" */ '../pages/property.vue')
    }, { //卡管理系统页面
      path: '/cardSystem',
      name: 'cardSystem',
      meta: '3-7',
      component: () => import( /* webpackChunkName: "cardSystem" */ '../pages/cardSystem.vue')
    }, { //门磁系统页面
      path: '/doorSystem',
      name: 'doorSystem',
      meta: '3-8',
      component: () => import( /* webpackChunkName: "doorSystem" */ '../pages/doorSystem.vue')
    },
    /* ---------------行业终端---------------------- */
    { //门磁页面
      path: '/door',
      name: 'door',
      meta: '4-1',
      component: () => import( /* webpackChunkName: "door" */ '../pages/door.vue')
    }, { //DTU页面
      path: '/DTU',
      name: 'DTU',
      meta: '4-2',
      component: () => import( /* webpackChunkName: "DTU" */ '../pages/DTU.vue')
    }, { //水质监测浮动站页面
      path: '/qualityMonitoring',
      name: 'qualityMonitoring',
      meta: '4-3',
      component: () => import( /* webpackChunkName: "qualityMonitoring" */ '../pages/qualityMonitoring.vue')
    }, { //地下型蚁情监测器页面
      path: '/antCondition',
      name: 'antCondition',
      meta: '4-4',
      component: () => import( /* webpackChunkName: "antCondition" */ '../pages/antCondition.vue')
    },
    { //关于我们页面
      path: '/about',
      name: 'about',
      meta: '5-1',
      component: () => import( /* webpackChunkName: "about" */ '../pages/about.vue')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js